// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoader_container__2Y4e7","loader":"PageLoader_loader__mrICg","loading":"PageLoader_loading__3ke6V","rotate":"PageLoader_rotate__1xVNp"};